 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_DEDICATION from '@/components/html/03_Dedication'
 import HTML04_CONTENTS from '@/components/html/04_CONTENTS'
 import HTML05_PREFACE from '@/components/html/05_Preface'
 import HTML06_ACKNOWLEDGMENTS from '@/components/html/06_Acknowledgments'
 import HTML07_1__MODERNIST_FORM_AND_THE_ETHICS from '@/components/html/07_1__Modernist_Form_and_the_Ethics'
 import HTML08_2__AGAINST_ALLEGORY__WAITING_FOR from '@/components/html/08_2__Against_Allegory__Waiting_for'
 import HTML09_3__THE_SILENCE_OF_THE_CANON__FOE from '@/components/html/09_3__The_Silence_of_the_Canon__Foe'
 import HTML10_4__TRUSTING_THE_OTHER__AGE_OF_IR from '@/components/html/10_4__Trusting_the_Other__Age_of_Ir'
 import HTML11_5__EXPECTING_THE_UNEXPECTED__THE from '@/components/html/11_5__Expecting_the_Unexpected__The'
 import HTML12_6__CONFESSING_IN_THE_THIRD_PERSO from '@/components/html/12_6__Confessing_in_the_Third_Perso'
 import HTML13_7__AGE_OF_BRONZE__STATE_OF_GRACE from '@/components/html/13_7__Age_of_Bronze__State_of_Grace'
 import HTML14_EPILOGUE__A_WRITER_S_LIFE__ELIZA from '@/components/html/14_Epilogue__A_Writer_s_Life__Eliza'
 import HTML15_NOTES from '@/components/html/15_Notes'
 import HTML15_WORKS_CITED from '@/components/html/15_Works_Cited'
 import HTML16_INDEX from '@/components/html/16_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_CONTENTS",
 			"name" : "html/04_CONTENTS",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Preface",
 			"name" : "html/05_Preface",
 			"component" : HTML05_PREFACE
 		},
 		{
 			"path" : "/html/06_Acknowledgments",
 			"name" : "html/06_Acknowledgments",
 			"component" : HTML06_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/html/07_1__Modernist_Form_and_the_Ethics",
 			"name" : "html/07_1__Modernist_Form_and_the_Ethics",
 			"component" : HTML07_1__MODERNIST_FORM_AND_THE_ETHICS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js